import {Component, OnInit} from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';
import {RouterService} from './services/router.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{

    topbarTheme: string = 'green';

    menuTheme: string = 'light';

    layoutMode: string = 'light';

    menuMode: string = 'static';

    inlineMenuPosition: string = 'top';

    inputStyle: string = 'filled';

    ripple: boolean = true;

    isRTL: boolean = false;

    constructor(private primengConfig: PrimeNGConfig,private routerService : RouterService) {}

    ngOnInit() {
        this.primengConfig.ripple = true;
        this.routerService.init();
    }
    onRTLChange(event) {
        this.isRTL = event.checked;
    }

    onRippleChange(event) {
        this.ripple = event.checked;
        this.primengConfig.ripple = event.checked;
    }
}
